import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSlice } from '@reduxjs/toolkit';
import { PAY_BTN_STATUSES } from "../../../constants/payment";
import { fetchBindingThunk, loadPsOperationDetails } from "./actions";
var initialState = {
  payData: null,
  qrScan: null,
  paymentStatus: PAY_BTN_STATUSES.initial,
  pendingBanksList: false,
  isOpen: false,
  fpsData: null,
  fpsBindingData: null,
  pendingBinding: false
};
export var fpsSlice = createSlice({
  name: 'features/fps',
  initialState: initialState,
  reducers: {
    commonSetter: function commonSetter(state, action) {
      return _objectSpread(_objectSpread({}, state), action.payload);
    },
    resetPayData: function resetPayData(state) {
      state.payData = null;
    },
    toggleIsOpen: function toggleIsOpen(state, action) {
      state.isOpen = action.payload;
    },
    setFpsData: function setFpsData(state, action) {
      state.fpsData = action.payload;
    },
    setFpsBindingData: function setFpsBindingData(state, action) {
      state.fpsBindingData = action.payload;
    },
    setPayData: function setPayData(state, action) {
      state.payData = action.payload;
    },
    setPaymentStatus: function setPaymentStatus(state, action) {
      state.paymentStatus = action.payload;
    },
    setQRScanResult: function setQRScanResult(state, action) {
      state.qrScan = action.payload;
    }
  },
  extraReducers: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, loadPsOperationDetails.rejected, function (state) {
    state.paymentStatus = PAY_BTN_STATUSES.error;
  }), loadPsOperationDetails.fulfilled, function (state, action) {
    state.paymentStatus = PAY_BTN_STATUSES.initial;
    state.payData = action.payload;
  }), fetchBindingThunk.pending, function (state) {
    state.pendingBinding = true;
  }), fetchBindingThunk.fulfilled, function (state, _ref) {
    var payload = _ref.payload;
    state.fpsBindingData = payload;
    state.pendingBinding = false;
  }), fetchBindingThunk.rejected, function (state) {
    state.fpsBindingData = null;
    state.pendingBinding = false;
  })
});